import * as Yup from 'yup';
import { ValidationRules } from "helpers/createFormConfig";
import { PlateformeFormFieldNames } from './PlateformeFormFieldNames';
import { ThemeFormValues } from './ThemeFormValues';

export const themeValidationRules: ValidationRules<keyof ThemeFormValues> = {
  [PlateformeFormFieldNames.PrimaryColor]: Yup.string()
    .required('La couleur primaire est requise'),
  [PlateformeFormFieldNames.SecondaryColor]: Yup.string()
    .required('La couleur secondaire est requise'),
  [PlateformeFormFieldNames.BackgroundColor]: Yup.string()
    .required('La couleur de fond est requise'),
  [PlateformeFormFieldNames.SurfaceColor]: Yup.string()
    .required('La couleur de surface est requise'),
  [PlateformeFormFieldNames.AccentColor]: Yup.string()
    .required("La couleur d'accent est requise"),
  [PlateformeFormFieldNames.ErrorColor]: Yup.string()
    .required("La couleur d'erreur est requise"),
  [PlateformeFormFieldNames.SuccessColor]: Yup.string()
    .required('La couleur de succès est requise'),
  [PlateformeFormFieldNames.WarningColor]: Yup.string()
    .required("La couleur d'avertissement est requise"),
  [PlateformeFormFieldNames.InfoColor]: Yup.string()
    .required("La couleur d'information est requise"),
  [PlateformeFormFieldNames.FontFamily]: Yup.string()
    .required('La police est requise'),
};

